export const fieldStates = {
  FOCUSED: 'FOCUSED',
  ERROR: 'ERROR',
  VALID: 'VALID',
  DEFAULT: 'DEFAULT',
  DISABLED: 'DISABLED',
}
